import { render, staticRenderFns } from "./DocumentList.vue?vue&type=template&id=1fb7154f&scoped=true&"
import script from "./DocumentList.vue?vue&type=script&lang=js&"
export * from "./DocumentList.vue?vue&type=script&lang=js&"
import style0 from "./DocumentList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DocumentList.vue?vue&type=style&index=1&id=1fb7154f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb7154f",
  null
  
)

export default component.exports